import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const FeaturesSection = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const [isInView, setIsInView] = useState(false);
  const [isScrollingDown, setIsScrollingDown] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const sectionElement = sectionRef.current;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrollingDown(currentScrollY > lastScrollY);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && isScrollingDown) {
          setIsInView(true);
        } else {
          setIsInView(false);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionElement) {
      observer.observe(sectionElement);
    }

    return () => {
      if (sectionElement) {
        observer.unobserve(sectionElement);
      }
    };
  }, [lastScrollY, isScrollingDown]);

  return (
    <Container
      className="mt-5 mb-lg-5 mb-md-4 mb-3"
      ref={sectionRef}
      id="features"
    >
      <h2
        className={`text-center mb-4 feature-title animate__animated ${
          isInView ? "animate__fadeIn" : ""
        }`}
      >
        {t("featuresPage.title")}
      </h2>
      <Row className="d-flex justify-content-center">
        {[
          {
            icon: "bi-check-circle",
            title: t("featuresPage.feature1.title"),
            description: t("featuresPage.feature1.description"),
          },
          {
            icon: "bi-person",
            title: t("featuresPage.feature2.title"),
            description: t("featuresPage.feature2.description"),
          },
          {
            icon: "bi bi-check-circle",
            title: t("featuresPage.feature3.title"),
            description: t("featuresPage.feature3.description"),
          },
          {
            icon: "bi-share",
            title: t("featuresPage.feature4.title"),
            description: t("featuresPage.feature4.description"),
          },
          {
            icon: "bi-gift",
            title: t("featuresPage.feature5.title"),
            description: t("featuresPage.feature5.description"),
          },
          {
            icon: "bi-bar-chart-line",
            title: t("featuresPage.feature6.title"),
            description: t("featuresPage.feature6.description"),
          },
        ].map((feature, index) => (
          <Col
            sm={12}
            md={6}
            lg={4}
            className="mb-lg-4 mb-md-4 mb-3"
            key={index}
          >
            <div
              className={`feature-card justify-content-center align-items-center h-100 w-100 d-flex ${
                isInView ? "animate__zoomIn" : ""
              }`}
            >
              <Card className="card-feature h-100 w-100 d-flex">
                <Card.Body className="text-start p-4 rounded-4 d-flex">
                  <Card.Title className="d-flex m-0 align-items-start justify-content-start pt-0 pe-3">
                    <i
                      className={`bi ${
                        feature.icon
                      } feature-icon m-0 animate__animated ${
                        isInView ? "animate__zoomIn" : ""
                      }`}
                    />
                  </Card.Title>
                  <div>
                    <span className="feature-text">{feature.title}</span>
                    <Card.Text className="feature-description mt-2">
                      {feature.description}
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default FeaturesSection;
